import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { OrderService } from "../../../order.service";
import { take } from "rxjs/operators";
import { Personnel } from "../../../../parties/model/personnel.model";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";

@Component({
  selector: "order-waiterfastaccess",
  templateUrl: "./waiterfastaccess.component.html",
  styleUrls: ["./waiterfastaccess.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WaiterFastAccessComponent extends BaseListComponent {
  _noWaiters: boolean = undefined;

  constructor(public order: OrderService, public cd: ChangeDetectorRef, __id: FormContainerModel) {
    super();
    this.currentTabId = __id.metadata.id;
    this.order.cd_FastAccessWaiter = cd;
    this.getWaiters();
  }
  ngOnInit() {}
  //دریافت گارسون ها
  getWaiters() {
    if (this.order?.waiters?.length > 0) {
      this.order.detectChanges();
      return;
    }
    this.httpCommonService
      .getList("Personnel/GetWaiterList")
      .pipe(take(1))
      .subscribe((data: Personnel[]) => {
        if (data.length > 0) {
          this.order.waiters = data;
          this.order.detectChanges();
        }
      });
  }
  //پر کردن نام گارسون در فاکتور جاری
  SetInvoiceWaiter(personnel: Personnel) {
    if (this.order.invoice.WaiterId !== personnel.Id) {
      this.order.invoice.WaiterId = personnel.Id;
      this.order.invoice.WaiterName = personnel.DisplayName;
      this.order.invoiceChanged = true;
      this.order.itemChanged = true;
    }
    this.order._opened = false;
    this.order.checkInvoiceState(this.order.invoice.CommandCode);
    this.order.detectChanges();
  }
}
